import React, {useContext, FC} from 'react';
import {useDispatch} from 'react-redux';

import {useFormButtonWatcher} from 'components/form/buttons/use-form-button-watcher/use-form-button-watcher';
import {selectTableEntityMetadata, setMetadata, ITableEntityMeta} from 'entities/metadata';
import {EEntityType} from 'shared/constants/entities';
import {useAppSelector} from 'store/config/hooks';

import {invertTableMode, ETableMode, TableModeContext} from '../../context';
import {ActionButton} from '../action-button';
import {TableAction} from '../table-action';
import {TABLE_ACTION_MAP} from '../table-action-constants';
import {ITableActionProps} from '../table-action-types';

export const disabledFields = (metaTable: ITableEntityMeta, isDisabled: boolean): ITableEntityMeta => {
    const fields = metaTable?.fields.map(field => ({...field, isDisabled}));
    return {...metaTable, fields};
};
export const disabledButtonSave = (disabled = true) => disabled;

export const ButtonActionEditFields: FC<ITableActionProps> = ({
    meta,
    wrapper,
    entityName,
    ...props
}: ITableActionProps) => {
    const dispatch = useDispatch();
    const {actionIcon, actionTitle} = meta;
    const {tableMode, setTableMode} = useContext(TableModeContext);
    const metaTableData = useAppSelector(selectTableEntityMetadata(entityName));
    const {
        isDisabled: isDisabledByWatcher,
    } = useFormButtonWatcher({actionsForm: meta, entityName});

    const handleClick = () => {
        const newMetaData = disabledFields(metaTableData, false);
        setTableMode(invertTableMode(tableMode));
        dispatch(setMetadata({
            entityName,
            entityType: EEntityType.TABLE,
            metadata: newMetaData,
        }));
        disabledButtonSave(false);
    };

    const Component = wrapper || ActionButton;
    if (meta?.childrens && tableMode === ETableMode.EDIT) {
        return (
            <>
                {meta.childrens?.map(child => (
                    TABLE_ACTION_MAP[child.actionType] ? (
                        <TableAction
                            key={child.actionTitle}
                            meta={child}
                            entityName={entityName}
                        />

                    ) : null
                ))}
            </>
        );
    }

    return (
        <Component
            {...props}
            actionIcon={actionIcon}
            onClick={handleClick}
            disabled={isDisabledByWatcher}
        >
            {actionTitle}
        </Component>
    );
};
